module.exports = __webpack_public_path__ + "img/home6.21239ac1.png";